define.alias("shared/errors/fetch", "calendar/errors/fetch");